import {
  Conversation,
  Message,
  Paginator,
  Participant,
} from '@twilio/conversations';
import { InfiniteData } from 'react-query';
import {
  ChatConversation,
  ChatMessage,
  ChatParticipant,
  ChatUser,
} from '../types';

export const queryKeys = {
  conversations: (userId: string) => ['chat', userId, 'conversations'],
  conversation: (userId: string, conversationSid: string) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'conversation',
  ],
  conversationName: (userId: string, uniqueName: string) => [
    'chat',
    userId,
    'conversation-name',
    uniqueName,
  ],
  messages: (userId: string, conversationSid: string) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'messages',
  ],
  message: (userId: string, conversationSid: string, messageSid: string) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'message',
    messageSid,
    'message',
  ],
  messageFiles: (
    userId: string,
    conversationSid: string,
    messageSid: string,
  ) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'message',
    messageSid,
    'files',
  ],
  lastMessage: (userId: string, conversationSid: string) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'lastMessage',
  ],
  participants: (userId: string, conversationSid: string) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'participants',
  ],
  participant: (
    userId: string,
    conversationSid: string | null | undefined,
    participantSid: string | null | undefined,
  ) => [
    'chat',
    userId,
    'conversation',
    conversationSid,
    'participant',
    participantSid,
  ],
  user: (userId: string, identity: string | null | undefined) => [
    'chat',
    userId,
    'user',
    identity,
  ],
};

export type QueryKeyTypes = {
  conversations: InfiniteData<Paginator<Conversation>>;
  conversation: ChatConversation;
  messages: InfiniteData<{
    messages: Array<ChatMessage>;
    paginator: Paginator<Message>;
  }>;
  message: ChatMessage;
  messageFiles: Array<{
    name: string;
    type: string;
    url: string;
  }>;
  lastMessage: ChatMessage | undefined;
  participants: Participant[];
  participant: ChatParticipant | undefined;
  user: ChatUser | undefined;
};
